import { DateRangePickerTranslateStrings } from '../../gzDateRangePicker/types';

export interface TimeRangeOption {
  label: string;
  value: number;
}

export enum TimeRangeEvents {
  TIMERANGE_CHANGE = 'timeRangeChange',
  ALL_TO_DATE = 'allToDateSelected',
}

export enum TimeIntervalPoints {
  FROM = 'fromTimestamp',
  TO = 'toTimestamp',
}

export interface DateTimeFilterTranslateStrings extends DateRangePickerTranslateStrings {
  customLabel: string;
  allToDate: string;
}
